import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  paper: {
    border: '0 !important',
  },
  content: {
    padding: 0,
  },
  contentText: {
    padding: '16px 16px 32px',
    marginBottom: 0,
    '& strong': {
      color: theme.palette.text.primary,
    },
    '& p': {
      color: theme.palette.text.secondary,
      '&:not(:last-of-child)': {
        marginBottom: 16,
      },
    },
  },
  actions: {
    justifyContent: 'space-between',
    '& div': {
      display: 'flex',
      gap: 8,
    },
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    marginBottom: 0,
    '&:not(:last-child)': {
      marginBottom: 24,
    },
  },
  iconContainer: {
    display: 'flex',
    padding: 16,
    border: `thin solid ${theme.palette.primary.main}`,
    backgroundColor: `${theme.palette.primary.main}08`,
  },
  iconSvg: {
    width: 32,
    height: 32,
    fill: theme.palette.primary.main,
  },
  description: {
    fontSize: 14,
    lineHeight: '150%',
  },
}));
